import { createQueryKeyStore } from "@lukemorales/query-key-factory";

export const clinicCalendarKeys = createQueryKeyStore({
  calendar: {
    list: (clinicId: number, departmentId: number) => [clinicId, departmentId],
  },
});
